package floris.graphics.models.dto.requests.techstack

import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.dto.requests.MediaFileDto
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TechstackDto(
    val id: String = "",
    val name: String = "",
    @SerialName("logo_media_file")
    val logoMediaFile: MediaFileDto? = null,
    val techstack: TechstackDto? = null,
    @SerialName("sub_techstacks")
    val subTechstacks: List<TechstackDto>? = null,
    @SerialName("created_at")
    override val createdAt: String = "",
    @SerialName("updated_at")
    override val updatedAt: String = "",
) : DateAble
